import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100/70">
      <div className="text-center mb-6 md:mb-8">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
          漫画分类
        </h2>
        <p className="text-sm text-foreground-500 mt-1">
          海量韩国漫画，总有你喜欢的类型
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4 max-w-4xl mx-auto">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
              <i className={`${cat.icon} text-xl md:text-2xl text-primary-600`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}